import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import constants from 'Constants';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';



class BaseBlockStore {

  @setter @observable blockMarginTop;
  @setter @observable blockMarginBottom;
  @setter @observable blockMarginLeft;
  @setter @observable blockMarginRight;

  @setter @toggle @observable overrideMobileBlockMargins;
  @setter @observable mobileBlockMarginTop;
  @setter @observable mobileBlockMarginBottom;
  @setter @observable mobileBlockMarginLeft;
  @setter @observable mobileBlockMarginRight;

  @setter @toggle @observable displayDesktop;
  @setter @toggle @observable displayMobile;

  static create(data={}) {
    const instance = new BaseBlockStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "blockMarginTop": "",
      "blockMarginBottom": "",
      "blockMarginLeft": "",
      "blockMarginRight": "",

      "overrideMobileBlockMargins": false,
      "mobileBlockMarginTop": "0",
      "mobileBlockMarginBottom": "0",
      "mobileBlockMarginLeft": "0",
      "mobileBlockMarginRight": "0",

      "displayDesktop": true,
      "displayMobile": true,
    };
  }

  constructor(defaults=BaseBlockStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=BaseBlockStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "blockMarginTop", "accessor": "block_margin_top"},
      {"field": "blockMarginBottom", "accessor": "block_margin_bottom"},
      {"field": "blockMarginLeft", "accessor": "block_margin_left"},
      {"field": "blockMarginRight", "accessor": "block_margin_right"},

      {"field": "overrideMobileBlockMargins", "accessor": "override_mobile_block_margins"},
      {"field": "mobileBlockMarginTop", "accessor": "mobile_block_margin_top"},
      {"field": "mobileBlockMarginBottom", "accessor": "mobile_block_margin_bottom"},
      {"field": "mobileBlockMarginLeft", "accessor": "mobile_block_margin_left"},
      {"field": "mobileBlockMarginRight", "accessor": "mobile_block_margin_right"},

      {"field": "displayDesktop", "accessor": "display_desktop"},
      {"field": "displayMobile", "accessor": "display_mobile"},
    ];
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  getBlockCssAttributes() {
    let attrs = {
      "display": this.displayDesktop ? "block" : "none",
      "margin": `${this.blockMarginTop}px ${this.blockMarginRight}px ${this.blockMarginBottom}px ${this.blockMarginLeft}px`,
    };

    return attrs;
  }

  @computed get blockCssAttributes() {
    let attrs = this.getBlockCssAttributes();
    return attrs;
  }

  getMobileBlockCssAttributes() {
    let attrs = {
      "display": this.displayMobile ? "block" : "none",
    };

    if (this.overrideMobileBlockMargins) {
      attrs['margin'] = `${this.mobileBlockMarginTop}px ${this.mobileBlockMarginRight}px ${this.mobileBlockMarginBottom}px ${this.mobileBlockMarginLeft}px`;
    }

    return attrs;
  }

  @computed get mobileBlockCssAttributes() {
    let attrs = this.getMobileBlockCssAttributes();
    return attrs;
  }
}


export default BaseBlockStore;
